import { MAX_REFERENCE_PROMPTS, MODEL_VERSION } from '@/app/constants';
import type { AllModelVersion, ModelVersion } from '@/app/types';

/**
 * Q2Video 模型支持的最大图片/主体数量（不包括视频）
 */
const MAX_IMAGE_REFERENCES = 4;

/**
 * 获取指定模型版本支持的最大图片+主体数量（不包括视频）
 *
 * 注意：视频也是 reference 的一部分，但此函数仅返回图片和主体的最大数量。
 * - Q2_PRO: 支持 1-2 个视频 + 4 个图片/主体，此函数返回 4
 * - 其他版本（2.0, q1, q2, q3）: 支持最多 7 个图片/主体（不支持视频），此函数返回 7
 *
 * @param modelVersion 模型版本
 * @returns 图片+图片/文字主体的最大数量（不包括视频）
 *
 */
export const getMaxImageAndElementCount = (modelVersion: AllModelVersion): number => {
  return modelVersion === MODEL_VERSION.Q2_PRO ? MAX_IMAGE_REFERENCES : MAX_REFERENCE_PROMPTS;
};

export const getMaxVideoElementCount = (modelVersion: ModelVersion): number => {
  return modelVersion === MODEL_VERSION.Q2_PRO ? 2 : 0;
};
